// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"c41f05ed","384":"ae130469","460":"44fd6e51"}[chunkId] + ".css";
};